import React from 'react';

import sslSecureLogo from '../images/ssl_secure.png';
import lhdnApprovedLogo from '../images/lhdn_approved_logo.png';

const Header = () => (
    <div className='header'>
        <div className='container'>
            <nav className='navbar navbar-expand-lg navbar-light'>
                <a className='navbar-brand' href='http://www.payrollpanda.my/'>
                    <img
                        className='logo'
                        src='https://uploads-ssl.webflow.com/5947262258fa7b4b26d8a770/595f01588521af175b3607b6_PP%20logo.png'
                        alt='PayrollPanda'
                        srcSet='https://uploads-ssl.webflow.com/5947262258fa7b4b26d8a770/595f01588521af175b3607b6_PP%20logo-p-500.png 500w,
                            https://uploads-ssl.webflow.com/5947262258fa7b4b26d8a770/595f01588521af175b3607b6_PP%20logo-p-800.png 800w,
                            https://uploads-ssl.webflow.com/5947262258fa7b4b26d8a770/595f01588521af175b3607b6_PP%20logo-p-1080.png 1080w,
                            https://uploads-ssl.webflow.com/5947262258fa7b4b26d8a770/595f01588521af175b3607b6_PP%20logo.png 2296w'
                        sizes='(max-width: 479px) 88vw, 160px' />

                    <img
                        className='icon'
                        src={sslSecureLogo}
                        alt=''
                        sizes='(max-width: 100px) 10vw, 80px'
                    />

                    <img
                        className='icon'
                        src={lhdnApprovedLogo}
                        alt=''
                        sizes='(max-width: 100px) 10vw, 80px'
                    />
                </a>

                <button className='navbar-toggler' type='button' data-toggle='collapse' data-target='#navbarSupportedContent' aria-controls='navbarSupportedContent' aria-expanded='false' aria-label='Toggle navigation'>
                    <div className='navbar-toggler-icon'>
                        <div className='black'></div>
                        <div className='green'></div>
                        <div className='black'></div>
                    </div>
                </button>

                <div className='collapse navbar-collapse' id='navbarSupportedContent'>


                     <form className="actions form-inline" style={{position: 'absolute', right: 0}}>
                        <a className="login btn" href="https://app.payrollpanda.my/#login?&utm_source=pcb-calculator&utm_medium=homepage">LOGIN</a>
                        <a className="get-started btn" href="https://app.payrollpanda.my/#signup?&utm_source=pcb-calculator&utm_medium=homepage">GET STARTED</a>

                    </form>
                </div>
            </nav>
        </div>
    </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js